
import HeaderSection from "../../../../../components/Header/HeaderSection"
import CardTransparent from "../../../../../components/CockpitCards/CardTransparent"

export default function DrugSearchText() {

    
    return (

    <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Get the" 
            headline_grey = "right drug - right dose "
            headline_p2 = "based on your pharmacogenetic profile"

            text1 = "The medication guide helps you understanding how your unique genetic makeup can influence your response to medications."
            text2 = "The information presented here is based on established clinical guidelines from trusted sources including the FDA, FDA-PGx, CPIC, and DPWG. By combining your genetic data with these recommendations, we aim to support safer and more effective treatment decisions tailored specifically to you."
            text3 =  "Whether you are currently taking medication or planning to start, this guide can provide valuable insights into which drugs may work best for your body, while minimizing side effects and improving therapeutic outcomes. We encourage you to share this information with your healthcare provider or pharmacist to support your ongoing care."

            />
    }/>
            
  )
}